<template>
  <div :data-view-id="componentUniqueTitle || uniqueTitle" class="staticimage-view">
    <ViewTitle :title="title" />
    <img
      v-if="imageUrl"
      :src="imageUrl"
      :alt="altText || title || 'Static image'"
      class="staticimage-view-img"
    />
    <div v-else class="staticimage-view-empty">
      <p>No image</p>
    </div>
  </div>
</template>

<script>
import ViewTitle from './ViewTitle.vue'

export default {
  name: 'StaticImageView',
  components: {
    ViewTitle
  },
  props: {
    uniqueTitle: { type: String, default: '' },
    title: { type: String, default: '' },
    staticImageId: { type: [Number, String], default: null },
    altText: { type: String, default: '' },
    componentUniqueTitle: { type: String, default: '' },
    pageUniqueTitle: { type: String, default: '' }
  },
  computed: {
    imageUrl () {
      if (!this.staticImageId) return null
      const base = (typeof VUE_APP_PROXY_SERVER_URL !== 'undefined') ? VUE_APP_PROXY_SERVER_URL : ''
      return `${base}/static-images/${this.staticImageId}`
    }
  }
}
</script>

<style scoped>
.staticimage-view {
  padding: 1rem;
}

.staticimage-view-img {
  max-width: 100%;
  height: auto;
  display: block;
}

.staticimage-view-empty {
  color: #999;
  font-style: italic;
}
</style>
